// api_worktime.js
import { ENDPOINT_ROUTES, BASE_URL } from "./routes";
import $ from "jquery";

const api = {
  fetchWorktimeSummary: async ({ userId, month, year }) => {
    const endpoint =
      BASE_URL +
      ENDPOINT_ROUTES.workTime +
      `/summary/${userId}?month=${month}&year=${year}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  exportWorkTime: async ({ dateFrom, dateTo, userIds }) => {
  const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/export`;

  return new Promise((resolve) => {
    $.ajax({
      url: endpoint,
      type: "POST",
      contentType: "application/json; charset=UTF-8",
      data: JSON.stringify({ dateFrom, dateTo, userIds }),
      xhrFields: {
        responseType: "blob",
      },
      success: (blob, status, xhr) => {
        resolve({
          success: true,
          content: {
            file: blob,
            type: xhr.getResponseHeader("Content-Type"),
          },
        });
      },
      error: (xhr) =>
        resolve({
          success: false,
          error: xhr.responseText,
          status: xhr.status,
        }),
    });
  });
},

  approveWorkTimeSummary: async ({ userId, entryIds }) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/approve`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "POST",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ userId, entryIds }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  getCurrentWorkTime: async () => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/current`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  fetchWorktimeHistory: async ({
    limit = 30,
    cursor = null,
    worktimeId = null,
    userId = null,
    source = null,
  } = {}) => {
    const params = new URLSearchParams({ limit });

    if (cursor !== null && cursor !== undefined) params.set("cursor", cursor);
    if (worktimeId) params.set("worktimeId", worktimeId);
    if (userId) params.set("userId", userId);
    if (source) params.set("source", source);

    const endpoint =
      BASE_URL + ENDPOINT_ROUTES.workTime + `/history?${params.toString()}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  fetchRange: async ({ monthFrom, yearFrom, monthTo, yearTo }) => {
    const endpoint =
      BASE_URL +
      ENDPOINT_ROUTES.workTime +
      `/range?monthFrom=${monthFrom}&yearFrom=${yearFrom}&monthTo=${monthTo}&yearTo=${yearTo}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  updateWorktimeDay: async ({ entryId, data }) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/day/${entryId}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "PATCH",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify(data),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
  deleteWorktimeDay: async (entryId) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/day/${entryId}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "DELETE",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  getWorktimeNote: async (entryId) => {
    const endpoint =
      BASE_URL + ENDPOINT_ROUTES.workTime + `/day/${entryId}/note`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "GET",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  createWorktimeNote: async ({ entryId, data }) => {
    const endpoint =
      BASE_URL + ENDPOINT_ROUTES.workTime + `/day/${entryId}/note`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "POST",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify(data),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  updateWorktimeNote: async ({ noteId, data }) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/note/${noteId}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "PATCH",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify(data),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  approveWorktimeNote: async ({ noteId, approved }) => {
    const endpoint =
      BASE_URL + ENDPOINT_ROUTES.workTime + `/note/${noteId}/approve`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "POST",
        contentType: "application/json; charset=UTF-8",
        data: JSON.stringify({ approved }),
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  deleteWorktimeNote: async (noteId) => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/note/${noteId}`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "DELETE",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  // bezparametrowe start
  startWork: async () => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/start`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "POST",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },

  // bezparametrowe zakończenie
  endWork: async () => {
    const endpoint = BASE_URL + ENDPOINT_ROUTES.workTime + `/end`;

    return new Promise((resolve) => {
      $.ajax({
        url: endpoint,
        type: "POST",
        success: (result) => resolve({ success: true, content: result }),
        error: (xhr) =>
          resolve({
            success: false,
            error: xhr.responseText,
            status: xhr.status,
          }),
      });
    });
  },
};

const worktimeApi = { api };

export default worktimeApi;
